import { IDownloadEntregaObraClienteArquivoAuxByIdUseCase } from "../../../presentation/useCases/read/download_entrega_obra_cliente_arquivo_aux_by_id_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DownloadEntregaObraClienteArquivoAuxByIdUseCase
 */

export class DownloadEntregaObraClienteArquivoAuxByIdUseCase
  implements IDownloadEntregaObraClienteArquivoAuxByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async downloadEntregaObraClienteArquivoAuxById(
    idEntregaObraClienteArquivoAux: number,
    imageName: string,
  ): Promise<void> {
    const blob = await this.repository.downloadEntregaObraClienteArquivoAuxById(idEntregaObraClienteArquivoAux);

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(imageName));
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  }
}
